import React, { useEffect } from 'react';
import { Redirect, Switch, useHistory, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import AppPaths from '../../AppPaths';
import SentryRoute from '../../SentryRoute';
import Checkout from '../Checkout';
import { inAppCancellation } from '../../lib/analytics/events';
import { useSeries3Context } from '../../contexts/Series3Context';
import MiniPDP, { MiniPDPProps } from '../../components/MiniPDP/MiniPDP';
import Cart from '../Cart';
import VerizonFiLogo from '../../assets/images/verizon-fi-logo.png';
import styles from './Verizon.module.scss';
import classNames from 'classnames';

function VerizonNavBar() {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <div className={classNames(styles.verizonNavBar, 'verizon-nav-bar')}>
      <img src={VerizonFiLogo} alt={t('verizon_fi_logo')} onClick={() => history.push(AppPaths.Verizon.Root)} />
    </div>
  );
}

function withContext(Component: React.ComponentType<MiniPDPProps>) {
  return function WithContext(props: MiniPDPProps) {
    return (
      <>
        <VerizonNavBar />
        <Component {...props} />
      </>
    );
  };
}

export default function Verizon() {
  const location = useLocation();

  useEffect(() => {
    let pageName;
    const pathname = location.pathname;
    if (pathname.startsWith('/verizon/product/')) {
      pageName = 'S3 Product Selection';
    } else if (pathname.startsWith('/verizon/bag')) {
      pageName = 'Cart';
    } else if (pathname.startsWith('/verizon/checkout/shipping')) {
      pageName = 'Checkout > Shipping';
    } else if (pathname.startsWith('/verizon/checkout/payment')) {
      pageName = 'Checkout > Payment';
    } else if (pathname.startsWith('/verizon/checkout/review')) {
      pageName = 'Checkout > Review';
    } else if (pathname.startsWith('/verizon/checkout/thank-you')) {
      pageName = 'Checkout > Thank You';
    } else {
      pageName = 'Landing Page';
    }

    inAppCancellation.verizonCheckoutFlow({}, pageName);
  }, [location]);

  const { isVerizon } = useSeries3Context();
  if (!isVerizon) {
    return <Redirect to={AppPaths.NotFound} />;
  }

  return (
    <Switch>
      <SentryRoute exact path="/verizon/bag" component={withContext(Cart)} />
      <SentryRoute path="/verizon/checkout" component={withContext(Checkout)} />
      <SentryRoute path="/verizon" component={withContext(MiniPDP)} />
    </Switch>
  );
}
